





















































































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";

// Mixins
import PaymentProvider from "@/components/app/global/payments/paymentProvider.vue";
import CurrenciesStore from "@/mixins/constants/currenciesStore";
import HasValidation from "@/mixins/HasValidation";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { AdjustTypes } from "@/data/enums";

// Types
import { ICurrency } from "@/models/constants";
import { IClient } from "@/models/clients";
import { ValidationObserver } from "vee-validate";

@Component
export default class AdjustWalletBalanceModal extends Mixins(
  PaymentProvider,
  CurrenciesStore,
  HasValidation
) {
  // Props

  @Prop({ required: true })
  public currencyCode!: ICurrency["code"];

  @Prop({ required: true })
  public client!: IClient;

  @Prop({ required: true })
  public amount!: number;

  // Refs

  public declare $refs: {
    observer: InstanceType<typeof ValidationObserver>;
    amount: HTMLFormElement;
  };

  // Data

  public adjustType = AdjustTypes.ADD;
  public amountValue = 0;
  public currency: ICurrency = {} as ICurrency;
  public isProcessing = false;

  // Methods

  public async validateBeforeSubmit() {
    if (!this.canAdjust) return;
    try {
      if (!(await this.validate())) throw this.$t("_.form_invalid");

      this.isProcessing = true;
      await this.adjustBalance();

      this.$store.dispatch("toast/show", {
        message: this.$t(
          "_sentence.account_credit.balance_successfully_adjusted"
        )
      });

      this.$emit("success");
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public async adjustBalance() {
    return this.$store.dispatch(
      `data/${DataModules.WALLETS}/adjustWalletBalance`,
      {
        accountId: this.accountId,
        data: {
          client_id: this.client.id,
          ...(this.client.import_id
            ? { import_id: this.client.import_id }
            : {}),
          currency_code: this.currencyCode,
          amount: `${this.adjustType === AdjustTypes.SUBTRACT ? "-" : ""}${
            this.amountValue
          }`
        }
      }
    );
  }

  // Computed

  public get accountId() {
    return this.client?.accounts?.[0]?.id;
  }

  public get adjustTypes() {
    return [
      {
        value: AdjustTypes.ADD,
        label: this.$t("_action.add_amount")
      },
      {
        value: AdjustTypes.SUBTRACT,
        label: this.$t("_action.subtract_amount")
      }
    ];
  }

  public get canAdjust() {
    return this.$userCan("adjust_wallet_balance");
  }

  // Watchers

  @Watch("currenciesLoaded")
  public currenciesLoadedWatcher() {
    this.currency = this.$_.find(this.currencies, [
      "code",
      this.currencyCode
    ]) as ICurrency;
  }

  @Watch("adjustType")
  public onTypeChange() {
    (this.$refs.amount.$el?.getElementsByClassName(
      "u-currency-input"
    )?.[0] as HTMLElement)?.focus();
  }
}
